import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import { formatUrl } from "@utils/formatUrl";

let serverUrl = getSecret('SERVER_MASTER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_PERIDIC_TASKS_CRONTAB_SCHEDULE(state, periodicTasksCrontabSchedule) {
    state.cached = periodicTasksCrontabSchedule
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchPeriodicTasksCrontabSchedule(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/scheduled_tasks/crontab_schedule/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_PERIDIC_TASKS_CRONTAB_SCHEDULE', request)
      return request
    })
  },

  fetchPeriodicTasksCrontabScheduleDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdatePeriodicTasksCrontabSchedule(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formatUrl(formData.url), formData)
    }else {
      promise =  axios.post(`${serverUrl}/scheduled_tasks/crontab_schedule/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deletePeriodicTasksCrontabSchedule(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}